import { render, staticRenderFns } from "./ConfigureSigns.vue?vue&type=template&id=b9f6b9fc&"
import script from "./ConfigureSigns.vue?vue&type=script&lang=js&"
export * from "./ConfigureSigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9f6b9fc')) {
      api.createRecord('b9f6b9fc', component.options)
    } else {
      api.reload('b9f6b9fc', component.options)
    }
    module.hot.accept("./ConfigureSigns.vue?vue&type=template&id=b9f6b9fc&", function () {
      api.rerender('b9f6b9fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/vistas/modals/ConfigureSigns.vue"
export default component.exports